import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./lib/redux/store";
import {BrowserRouter as Router,} from 'react-router-dom'
import { baseURL } from "./Api/apis";
// if (baseURL !== 'https://erp-dev.mocion.io'  ) {
//   console.log = () => {};
// }
// if(baseURL == 'https://erp.mocion.io'){
//   console.log = console.warn = console.info = console.debug = () => {};
// }


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
     
    <Provider store={store}>
    <Router>
      <App />
      </Router>
    </Provider>
    

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
